import { Select } from 'antd'
import { Form, Modal, Spinner } from 'react-bootstrap'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { GiCancel } from 'react-icons/gi'
import demoImg from '../../../assets/images/demoLogoImg.png'
import {
  CreateScreenEnd,
  FileUploadEnd,
  GetAllCateEnd,
  GetThemeEnd,
} from '../../../constants/api.constants'
import Toast from '../../../utils/Toast/Toast'
import InputRange from 'react-input-range'
import ReactSelect from 'react-select';

const CreateNewScreen = ({ show, handleClose, store, loadStoreScreen , allCate }) => {
  const [catInfo, setCatInfo] = useState([])
  const [themes, setThemes] = useState([])
  const [newScreenData, setNewScreenData] = useState({
    theme_id: '',
    category_names: [],
    screen_name: '',
    screen_type: 'category-screen',
  })
  const [spinner, setSpinner] = useState(false)
  // const [allCate, setAllCate] = useState([])
  const [photoUrl, setPhotoUrl] = useState('')
  const [photoSpinner, setPhotoSpinner] = useState(false)
  const [searchTheme, setSearchTheme] = useState('')
  const [selectedTheme, setSelectedTheme] = useState('')
  const [screenOrientation, setScreenOrientation] = useState('portrait');
  const [showOnlyAds, setShowOnlyAds] = useState(false);
  // useEffect(() => {
  //   if(store._id)getAllCate()
  // }, [store])

  useEffect(() => {
    getAllTheme()    
  }, [searchTheme])

  // const getAllCate = async () => {
  //   try {
  //       const res = await axios.get(GetAllCateEnd + `?store_id=${store?._id}`, {
  //         headers: {
  //           menuboard: localStorage.getItem('menu_token'),
  //         },
  //       })
  
  //       if (res.status === 200) {
  //         setAllCate(res?.data?.data)
  //       } else throw new Error(res?.data?.msg || 'Try again later!')  
      
  //   } catch (error) {}
  // }

  const getAllTheme = async () => {
    try {
      const res = await axios.get(GetThemeEnd + `?name=${searchTheme}`, {
        headers: {
          menuboard: localStorage.getItem('menu_token'),
        },
      })

      if (res.status === 200) {
        setThemes(res?.data?.data)
      } else throw new Error(res?.data?.msg || 'Try again later!')
    } catch (error) {}
  }

  const handleCreate = async () => {
    setSpinner(true)
    let mergedData = {
      screen_name: newScreenData.screen_name,
      screen_type: newScreenData.screen_type,
      theme_id: newScreenData.theme_id,
      store_id: store?._id,
      orientation: screenOrientation,
    }

    let mergedCat = []
    for (const i of catInfo) {
      mergedCat.push({
        name: i?.cat_name,
        product_count_start: i?.value?.min,
        product_count_end: i?.value?.max,
      })
    }

    mergedData = {
      ...mergedData,
      category: mergedCat,
      preview: photoUrl,
      show_only_ads: showOnlyAds,
    }

    if (!mergedData?.screen_name) {
      Toast('err', 'Screen name is required')
      setSpinner(false)
      return
    }
    if (mergedData?.category.length === 0) {
      Toast('err', 'Category is required')
      setSpinner(false)
      return
    }
    if (!mergedData?.theme_id) {
      Toast('err', 'Theme is required')
      setSpinner(false)
      return
    }

    try {
      const res = await axios.post(
        CreateScreenEnd,
        { ...mergedData },
        {
          headers: {
            menuboard: localStorage.getItem('menu_token'),
          },
        }
      )

      if (res.status === 200) {
        setSpinner(false)
        Toast('success', 'Screen created successfully')
        handleClose()
        loadStoreScreen()
        setNewScreenData({
          theme_id: '',
          category_names: [],
          screen_name: '',
          screen_type: 'category-screen',
        })
        setPhotoUrl('')
        setCatInfo([])
        setShowOnlyAds(false)
        mergedData = {};
      } else throw new Error(res?.data?.msg || 'Try again later!')
    } catch (error) {
      setSpinner(false)
      Toast('err', error.response?.data?.msg || 'Try again later!')
    }
  }

  const removeCate = (item) => {
    const newCate = newScreenData?.category_names.filter((c) => c !== item)
    setNewScreenData({
      ...newScreenData,
      category_names: newCate,
    })
    const filteredCatInfo = catInfo?.filter((f) => f?.cat_name !== item)
    setCatInfo(filteredCatInfo)
  }

  const handleCate = (newCate) => {
    if (!newScreenData?.category_names.includes(newCate)) {
      let newArr = newScreenData?.category_names
      newArr.push(newCate)
      setNewScreenData({
        ...newScreenData,
        category_names: newArr,
      })
      setCatInfo([...catInfo, { cat_name: newCate, value: { max: 0, min: 0 } }])
    }
  }

  const handleProductCount = (value, c) => {
    let newArr = []
    let len = catInfo.length
    for (let i = 0; i < len; i++) {
      if (catInfo[i]?.cat_name !== c) newArr.push(catInfo[i])
      else {
        newArr.push({ cat_name: catInfo[i]?.cat_name, value: value })
      }

      if (i === len - 1) {
        setCatInfo(newArr)
      }
    }
  }

  const handleImageUpload = async (e) => {
    setPhotoSpinner(true)
    const file = e.target.files[0]

    const formData = new FormData()
    
    formData.append('files', file)

    try {
      const res = await axios.post(FileUploadEnd, formData, {
        headers: {
          menuboard: localStorage.getItem('menu_token'),
        },
      })
      if (res.status === 200) {
        setPhotoUrl(res.data?.files[0]?.path)
        setPhotoSpinner(false)
        Toast('success', 'File uploaded successfully')
      }
    } catch (error) {
      setPhotoSpinner(false)
      setPhotoUrl(null)
    }
  }

  const options = ['portrait', 'landscape', 'App Portrait']
  return (
    // <Modal show={show} onHide={handleClose} size='lg'>
    //   <Modal.Header closeButton style={{ border: 'none' }}>
    //     <Modal.Title style={{ fontSize: '22px' }}>
    //       Create New Screen for 
    //       {store?.name}{' '}
    //     </Modal.Title>
    //   </Modal.Header>
    //   {/* <Modal.Body>
    //     <div className='my-3'>
    //       <div className='d-flex justify-content-start align-items-end'>
    //         <img
    //           src={photoUrl || demoImg}
    //           alt=''
    //           height='100'
    //           width='200'
    //           className='me-4'
    //         />

    //         <Form.Group className='' controlId='formBasicEmail'>
    //           <Form.Label>
    //             Image
    //             {photoSpinner && (
    //               <Spinner className='ms-1' animation='border' size='sm' />
    //             )}
    //           </Form.Label>
    //           <Form.Control
    //             type='file'
    //             onChange={(e) => handleImageUpload(e)}
    //           />
    //         </Form.Group>
    //       </div>
    //       <div className='plain-input my-3'>
    //         <label for=''> Screen Name*</label>
    //         <br />
    //         <input
    //           type='text'
    //           placeholder='Screen Name'
    //           value={newScreenData?.screen_name}
    //           onChange={(e) =>
    //             setNewScreenData({
    //               ...newScreenData,
    //               screen_name: e.target.value,
    //             })
    //           }
    //         />
    //       </div>
    //       <div className='screen-types my-3'>
    //         <p className='fw-bold mb-2'>Screen Type*</p>
    //         <button
    //           className={
    //             newScreenData?.screen_type === 'click-n-collect'
    //               ? 'btn-white-bg me-2'
    //               : 'primary-btn-light me-2'
    //           }
    //           onClick={() => {
    //             setNewScreenData({
    //               ...newScreenData,
    //               screen_type: 'category-screen',
    //             })
    //           }}
    //         >
    //           Category Screen
    //         </button>{' '}
    //         <button
    //           className={
    //             newScreenData?.screen_type === 'click-n-collect'
    //               ? 'primary-btn-light me-2 '
    //               : 'btn-white-bg me-2'
    //           }
    //           onClick={() => {
    //             setNewScreenData({
    //               ...newScreenData,
    //               screen_type: 'click-n-collect',
    //             })
    //           }}
    //         >
    //           Click-n-Collect
    //         </button>
    //       </div>
    //        <div className='plain-dropdown my-3'>
    //         <label for=''>Product Count*</label>
    //         <InputRange
    //           maxValue={2000}
    //           minValue={0}
    //           value={rangeValue.value}
    //           onChange={(value) => setRangeValue({ value })}
    //           style={{ padding: '0px 10px' }}
    //         />
    //       </div> 
    //       <div className='plain-input my-3'>
    //         <label for=''> Category*</label>
    //         <br />
    //         <input
    //           type='text'
    //           placeholder='enter category name'
    //           onKeyDown={(e) => {
    //             handleKeyDown(e)
    //           }}
    //         />
    //       </div> 

    //       <div className='plain-dropdown mt-3'>
    //         <label for=''>Category*</label>
    //         <select onChange={(e) => handleCate(e.target.value)}>
    //           <option value='' hidden>
    //             not selected
    //           </option>
    //           {allCate?.map((c, idx) => (
    //             <option value={c} key={idx}>
    //               {c}
    //             </option>
    //           ))}
    //         </select>
    //       </div>

    //       <div className='mt-3'>
    //         {newScreenData?.category_names?.map((c, idx) => (
    //           <div key={idx}>
    //             <div
    //               style={{ backgroundColor: '#e1e1e1', borderRadius: '4px' }}
    //               className=' py-2 px-3  me-2 mt-2 d-flex justify-content-between align-items-center'
    //             >
    //               {c}{' '}
    //               <GiCancel
    //                 className='ms-2'
    //                 onClick={() => removeCate(c)}
    //                 style={{ cursor: 'pointer' }}
    //               />
    //             </div>
    //             <div className='plain-dropdown my-3'>
    //               <label for=''>Product Count For {c}*</label>
    //               <InputRange
    //                 maxValue={2000}
    //                 minValue={0}
    //                 value={catInfo?.find((f) => f?.cat_name === c)?.value}
    //                 // value={rangeValue?.value}
    //                 onChange={(value) => handleProductCount(value, c)}
    //                 style={{ padding: '0px 10px' }}
    //               />
    //             </div>
    //           </div>
    //         ))}
    //       </div>

    //       <div className='plain-dropdown mt-4'>
    //         <label for=''>Layout Theme*</label>
    //         <select
    //           onChange={(e) =>
    //             setNewScreenData({
    //               ...newScreenData,
    //               theme_id: e.target.value,
    //             })
    //           }
    //         >
    //           <option hidden>no theme selected</option>
    //           {themes.length > 0 &&
    //             themes.map((theme, idx) => (
    //               <option key={idx} value={theme?._id}>
    //                 {theme?.name}
    //               </option>
    //             ))}
    //         </select>
    //       </div>

    //       <div className='plain-input my-3'>
    //         <label for=''>Screen Password*</label>
    //         <br />
    //         <input type='text' />
    //       </div>
    //     </div>
    //     <div>
    //       <label
    //         style={{
    //           marginBottom: '0.7rem',
    //           fontWeight: 'bold',
    //         }}
    //       >
    //         Select Theme*
    //       </label>
    //       <br />

    //       <Select
    //         className='w-100'
    //         suffixIcon=''
    //         showSearch
    //         autoFocus={false}
    //         onChange={(t) =>
    //           setNewScreenData({
    //             ...newScreenData,
    //             theme_id: t.slice(0, 24),
    //           })
    //         }
    //         onSearch={(s) => {
    //           setSearchTheme(s)
    //         }}
    //         filterOption={false}
    //       >
    //         <option value=''>asdasd</option>
    //         {themes?.map((t, idx) => (
    //           <option key={idx} value={t?._id + t?.name} selected={t?.name==="default"?true:false}>
    //             {t?.name}
    //           </option>
    //         ))}
    //       </Select>
    //     </div>
    //   </Modal.Body> */}
    //   <Modal.Body>
    //     <div className='mb-3'>
    //       <div className='d-flex justify-content-start align-items-end'>
    //         <img
    //           src={photoUrl || demoImg}
    //           alt=''
    //           height='100'
    //           width='200'
    //           className='me-4'
    //         />

    //         <Form.Group className='' controlId='formBasicEmail'>
    //           <Form.Label>
    //             Image
    //             {photoSpinner && (
    //               <Spinner className='ms-1' animation='border' size='sm' />
    //             )}
    //           </Form.Label>
    //           <Form.Control type='file' onChange={(e) => handleImageUpload(e)} />
    //         </Form.Group>
    //       </div>
    //       <div className='plain-input my-3'>
    //         <label for=''> Screen Name*</label>
    //         <br />
    //         <input
    //           type='text'
    //           placeholder='Screen Name'
    //           value={newScreenData?.screen_name}
    //           onChange={(e) =>
    //             setNewScreenData({
    //               ...newScreenData,
    //               screen_name: e.target.value,
    //             })
    //           }
    //         />
    //       </div>
    //       <div className='screen-types my-3'>
    //         <p className='fw-bold mb-2'>Screen Type*</p>
    //         <button
    //           className={
    //             newScreenData?.screen_type === 'click-n-collect'
    //               ? 'btn-white-bg me-2'
    //               : 'primary-btn-light me-2'
    //           }
    //           onClick={() => {
    //             setNewScreenData({
    //               ...newScreenData,
    //               screen_type: 'category-screen',
    //             })
    //           }}
    //         >
    //           Category Screen
    //         </button>{' '}
    //         <button
    //           className={
    //             newScreenData?.screen_type === 'click-n-collect'
    //               ? 'primary-btn-light me-2 '
    //               : 'btn-white-bg me-2'
    //           }
    //           onClick={() => {
    //             setNewScreenData({
    //               ...newScreenData,
    //               screen_type: 'click-n-collect',
    //             })
    //           }}
    //         >
    //           Click-n-Collect
    //         </button>
    //       </div>

    //       <div className='plain-dropdown mt-3'>
    //         <label for=''>Category*</label>
    //         <select onChange={(e) => handleCate(e.target.value)}>
    //           <option value='' hidden selected>
    //             not selected
    //           </option>
    //           {allCate?.map((c, idx) => (
    //             <option value={c} key={idx}>
    //               {c}
    //             </option>
    //           ))}
    //         </select>
    //       </div>

    //       <div className='mt-3'>
    //         {newScreenData?.category_names?.map((c, idx) => (
    //           <div key={idx}>
    //             <div
    //               style={{ backgroundColor: '#e1e1e1', borderRadius: '4px' }}
    //               className=' py-2 px-3  me-2 mt-2 d-flex justify-content-between align-items-center'
    //             >
    //               {c}{' '}
    //               <GiCancel
    //                 className='ms-2'
    //                 onClick={() => removeCate(c)}
    //                 style={{ cursor: 'pointer' }}
    //               />
    //             </div>
    //             <div
    //               style={{
    //                 display: 'flex',
    //                 justifyContent: 'space-between',
    //                 margin: '1rem 0',
    //               }}
    //             >
    //               <div>
    //                 <label style={{ fontWeight: 'bold' }}>start count</label>
    //                 <input
    //                   type='number'
    //                   placeholder={catInfo[idx]?.value.min}
    //                   onChange={(e) => {
    //                     const arr = [...catInfo]
    //                     arr.splice(idx, 1, {
    //                       cat_name: c,
    //                       value: {
    //                         min: e.target.value,
    //                         max: catInfo[idx]?.value.max,
    //                       },
    //                     })
    //                     setCatInfo(arr)
    //                   }}
    //                   style={{
    //                     border: '1px solid gray',
    //                     padding: '5px 5px',
    //                     overflow: 'hidden',
    //                   }}
    //                 />
    //               </div>
    //               <div>
    //                 <label style={{ fontWeight: 'bold' }}>end count</label>
    //                 <input
    //                   type='number'
    //                   placeholder={catInfo[idx]?.value.max}
    //                   onChange={(e) => {
    //                     const arr = [...catInfo]
    //                     arr.splice(idx, 1, {
    //                       cat_name: c,
    //                       value: {
    //                         max: e.target.value,
    //                         min: catInfo[idx]?.value.min,
    //                       },
    //                     })
    //                     setCatInfo(arr)
    //                   }}
    //                   style={{
    //                     border: '1px solid gray',
    //                     padding: '5px 5px',
    //                     overflow: 'hidden',
    //                   }}
    //                 />
    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //       <div>
    //         <label
    //           style={{
    //             marginBottom: '0.7rem',
    //             fontWeight: 'bold',
    //           }}
    //         >
    //           Select Theme*
    //         </label>
    //         <br />

    //         <Select
    //           className='w-100'
    //           suffixIcon=''
    //           showSearch
    //           autoFocus={false}
    //           onChange={(t) =>
    //             setNewScreenData({
    //               ...newScreenData,
    //               theme_id: t.slice(0, 24),
    //             })
    //           }
    //           onSearch={(s) => {
    //             setSearchTheme(s)
    //           }}
    //           filterOption={false}
    //         >
    //           {themes?.map((t, idx) => (
    //             <option key={idx} value={t?._id + t?.name}>
    //               {t?.name}
    //             </option>
    //           ))}
    //         </Select>
    //       </div>
    //     </div>
    //   </Modal.Body>
    //   <Modal.Footer>
    //     <button className='primary-btn-light' onClick={handleClose}>
    //       Close
    //     </button>
    //     <button className='primary-btn' onClick={handleCreate}>
    //       Create Screen {spinner && <Spinner animation='border' size='sm' />}
    //     </button>
    //   </Modal.Footer>
    // </Modal>

    <Modal show={show} onHide={handleClose} size='lg'
      // destroyOnClose={true}
    >
       <Modal.Header closeButton style={{ border: 'none' }}>
        <Modal.Title style={{ fontSize: '22px' }}>
        {`Create New Screen for ${store?.name}`}
        </Modal.Title>
      </Modal.Header>
       <Modal.Body>
       <div className='mb-3'>
        <div className='d-flex justify-content-start align-items-end'>
          <img
            src={photoUrl || demoImg}
            alt=''
            height='100'
            width='200'
            className='me-4'
          />

          <Form.Group className='' controlId='formBasicEmail'>
            <Form.Label>
              Image
              {photoSpinner && (
                <Spinner className='ms-1' animation='border' size='sm' />
              )}
            </Form.Label>
            <Form.Control type='file' onChange={(e) => handleImageUpload(e)} />
          </Form.Group>
        </div>
        <div className='plain-input my-3'>
          <label for=''> Screen Name*</label>
          <br />
          <input
            type='text'
            placeholder='Screen Name'
            value={newScreenData?.screen_name}
            onChange={(e) =>
              setNewScreenData({
                ...newScreenData,
                screen_name: e.target.value,
              })
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleCreate();
              }
            }}
          />
        </div>
        <div className='screen-types my-3'>
          <p className='fw-bold mb-2'>Screen Type*</p>
          <button
            className={
              newScreenData?.screen_type === 'category-screen'
                ?   'primary-btn-light me-2' 
                : 'btn-white-bg me-2'
            }
            onClick={() => {
              setNewScreenData({
                ...newScreenData,
                screen_type: 'category-screen',
              })
            }}
          >
            Category Screen
          </button>{' '}
          <button
            className={
              newScreenData?.screen_type === 'click-n-collect'
                ? 'primary-btn-light me-2 '
                : 'btn-white-bg me-2'
            }
            onClick={() => {
              setNewScreenData({
                ...newScreenData,
                screen_type: 'click-n-collect',
              })
            }}
          >
            Click-n-Collect
          </button>
          <button
            className={
              newScreenData?.screen_type === 'Alcohol'
                ? 'primary-btn-light me-2 '
                : 'btn-white-bg me-2'
            }
            onClick={() => {
              setNewScreenData({
                ...newScreenData,
                screen_type: 'Alcohol',
              })
            }}
          >
            Alcohol
          </button>
          
        </div>

        <div className='plain-dropdown mt-3'>
          <label for=''>Category*</label>
          {
            allCate?.length > 0 ? (
              <ReactSelect
                options={allCate.map((c) => ({
                  value: typeof c === 'string' ? c : c.name,
                  label: typeof c === 'string' ? c : `${c.name} (${c.count} products)`,
                }))}
                onChange={(selectedOption) => handleCate(selectedOption?.value)}
                placeholder="Select category..."
                isClearable
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '45px',
                    borderColor: '#d1d5db',
                    '&:hover': {
                      borderColor: '#558f55',
                    },
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                      ? '#558f55'
                      : state.isFocused
                      ? '#e8f5e8'
                      : 'white',
                    color: state.isSelected ? 'white' : '#333',
                    '&:active': {
                      backgroundColor: '#558f55',
                    },
                  }),
                }}
              />
            ) : (
              <p>Loading categories...</p>
            )
          }
        </div>




        <div className='plain-dropdown mt-3'>
  <label htmlFor='screen-orientation'>Screen Orientation*</label>
  <select
    id='screen-orientation'
    onChange={(e) => setScreenOrientation(e.target.value)}
    value={screenOrientation}
  >
    {options.map((option) => (
      <option key={option} value={option}>
        {option}
      </option>
    ))}
  </select>
</div>



        <div className='mt-3'>
          {newScreenData?.category_names?.map((c, idx) => (
            <div key={idx}>
              <div
                style={{ backgroundColor: '#e1e1e1', borderRadius: '4px' }}
                className=' py-2 px-3  me-2 mt-2 d-flex justify-content-between align-items-center'
              >
                {c}{' '}
                <GiCancel
                  className='ms-2'
                  onClick={() => removeCate(c)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  margin: '1rem 0',
                }}
              >
                <div>
                  <label style={{ fontWeight: 'bold' }}>start count</label>
                  <input
                    type='number'
                    placeholder={catInfo[idx]?.value.min}
                    onChange={(e) => {
                      const arr = [...catInfo]
                      arr.splice(idx, 1, {
                        cat_name: c,
                        value: {
                          min: e.target.value,
                          max: catInfo[idx]?.value.max,
                        },
                      })
                      setCatInfo(arr)
                    }}
                    style={{
                      border: '1px solid gray',
                      padding: '5px 5px',
                      overflow: 'hidden',
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontWeight: 'bold' }}>end count</label>
                  <input
                    type='number'
                    placeholder={catInfo[idx]?.value.max}
                    onChange={(e) => {
                      const arr = [...catInfo]
                      arr.splice(idx, 1, {
                        cat_name: c,
                        value: {
                          max: e.target.value,
                          min: catInfo[idx]?.value.min,
                        },
                      })
                      setCatInfo(arr)
                    }}
                    style={{
                      border: '1px solid gray',
                      padding: '5px 5px',
                      overflow: 'hidden',
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className='plain-dropdown mt-3'>
          <label
            style={{
              marginBottom: '0.7rem',
              fontWeight: 'bold',
            }}
          >
            Select Theme*
          </label>
          <br />

          <select
            className='w-100'
            suffixIcon=''
            showSearch
            autoFocus={false}
            onChange={(t) =>
              setNewScreenData({
                ...newScreenData,
                theme_id: t.target.value,
              })
            }
            onSearch={(s) => {
              setSearchTheme(s)
            }}
            filterOption={false}
          >
            <option>
              Not Selected
            </option>
            {themes?.map((t, idx) => (
              <option key={idx} value={t?._id}>
                {t?.name}
              </option>
            ))}
          </select>
        </div>

        <div className='my-3'>
          <Form.Check
            type='switch'
            id='show-only-ads-create'
            label='Show Only Ads on Screen'
            checked={showOnlyAds}
            onChange={(e) => setShowOnlyAds(e.target.checked)}
          />
        </div>
      </div>
       </Modal.Body>
       
      <Modal.Footer>
        <button className='primary-btn-light me-3' onClick={handleClose}>
          Close
        </button>
        <button className='primary-btn' onClick={handleCreate}>
          Create Screen {spinner && <Spinner animation='border' size='sm' />}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateNewScreen
